<template>
  <div class="credit-details-unknown">
    <div class="header">
      <h3>{{ $t('STATISTICS.CREDIT_DETAILS.ENTRY_TYPE.UNKNOWN') }}</h3>
      <SmartFaqLink :link="helpTarget" />
    </div>
    <h1>
      {{ sprdCurrency(data.payoutAmount, data.currencyId) }}
    </h1>
    <div class="sub-details">
      {{ $t('DATE.BOOKED') }}:
      {{ date(data.dateBooked, 'longDate') }}
    </div>
    <div class="reasons">
      {{ $t('STATISTICS.CREDIT_DETAILS.UNKNOWN_COMMISSION') }}
    </div>
  </div>
</template>

<script>
import SmartFaqLink from 'commons/helpLink/SmartFaqLink.vue';
import smartFaqLinks from 'commons/smartFaq/smartFaqLinks';

export default {
  name: 'CreditDetailsUnknown',
  components: {
    SmartFaqLink,
  },
  props: ['data'],
  data() {
    return {
      helpTarget: smartFaqLinks.HELP_CENTER,
    };
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/styleguide/type';
@import 'src/scss/utils';

.credit-details-unknown {
  h1,
  h3 {
    margin: 0;
  }

  h1 {
    margin-top: 8px;
  }

  .sub-details {
    display: flex;
    margin-top: 4px;
    @extend .text-sm;
    @extend .text-grey;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .reasons {
    margin-top: 24px;
    text-align: left;
  }
}
</style>
